export default __webpack_public_path__ + "static/media/longscreens-MVhcp.f8bfcb15.jpg";